import s from "./english-mma.module.css";

function EnglishMma() {
    return (
        <div className={s.englishMma}>Produce Man-at-Arms +50% faster</div>
    )
}

export default EnglishMma;
